import { render, staticRenderFns } from "./SignUpComplete.vue?vue&type=template&id=498862c8&scoped=true"
import script from "./SignUpComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpComplete.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignUpComplete.vue?vue&type=style&index=0&id=498862c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498862c8",
  null
  
)

export default component.exports